import React, {useContext} from 'react';
import {IconPresentation} from "../../../shared/components/HosannaIcons";
import {AppCtx} from "../../../AppCtx";
import {ThemeContext} from "../../../ThemeContext";

/** @deprecated Hidden from the simplified catalogue menu. */
export default () => {
  const {isPresentationMode, setIsPresentationMode} = useContext(AppCtx);
  const {theme} = useContext(ThemeContext);
  const direct = process.env.REACT_APP_HOSANNA_DIRECT === '1';
  const label = direct ? (isPresentationMode ? 'Zamknij ekran prezentacji' : 'Ekran prezentacji na tym urządzeniu')
    : isPresentationMode ? 'Zakończ prezentację' : 'Rozpocznij prezentację';
  // Same look as the other menu toggles: icon only, highlighted while active.
  return <button type="button" onClick={()=>setIsPresentationMode(!isPresentationMode)}
              style={{cursor:'pointer',borderRadius:'30%',padding:'5px',border:'none',outline:'none',
                backgroundColor: isPresentationMode ? 'var(--active-item-bg-color)' : 'transparent'}}
              aria-pressed={isPresentationMode}
              aria-label={label} title={label}>
    <IconPresentation style={{color: isPresentationMode ? 'var(--active-item-text-color)'
      : theme === 'dark' ? 'var(--icon-color-dark)' : 'var(--menu-icon-inactive-color)'}}/>
  </button>;
};
